export default __webpack_public_path__ + "static/media/Frota (Real Size).5341aaaa.svg";